import { Box, Stack } from '@mui/material';

import { AccordionWithHeading, ContentLoading } from '../../../components/general';
import { HeadingWithTag } from '../../../components/general/HeadingWithTag.tsx';
import { LabelValue } from '../../../components/general/LabelValue.tsx';
import { type TerminProps } from '../../../utils';
import { TermineImPlanungsintervall } from './TermineImPlanungsintervall';
import { content } from './TerminPlanungsstatusCard.content';
import {
  getWorkflowStatusWithTooltip,
  printPlanungszeitraum,
  printTermineImPlanungsintervall,
} from './TerminPlanungsstatusCard.utils.js';

type TerminPlanungsstatusCardProps = TerminProps;

export const TerminPlanungsstatusCard = ({ thema }: TerminPlanungsstatusCardProps) => {
  const { planungsinformation } = thema;
  if (!planungsinformation) {
    return (
      <AccordionWithHeading heading={content.heading}>
        <ContentLoading />
      </AccordionWithHeading>
    );
  }

  return (
    <AccordionWithHeading heading={<HeadingWithTag heading={content.heading} tag="cserv" />} grow={true} noAccordion>
      <Stack spacing={3}>
        <Stack spacing={1.5}>
          <LabelValue label={content.fields.planungszeitraum} value={printPlanungszeitraum(planungsinformation)} />
          <LabelValue label={content.fields.workflowStatus} value={getWorkflowStatusWithTooltip(planungsinformation)} />
        </Stack>
        <Box>
          <LabelValue
            label={<TermineImPlanungsintervall />}
            value={printTermineImPlanungsintervall(planungsinformation)}
          />
        </Box>
      </Stack>
    </AccordionWithHeading>
  );
};
